import { BRANDS_FETCH, BRANDS_ADD } from "../constants/actionTypes";

export const doFetchBrands = () => ({
  type: BRANDS_FETCH,
});

export const doSaveBrands = brands => ({ type: BRANDS_ADD, payload: brands });
